import { render, staticRenderFns } from "./ListWizard.vue?vue&type=template&id=c83e5670"
import script from "./ListWizard.vue?vue&type=script&lang=js"
export * from "./ListWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports